var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "url(#paint0_linear_28_4840)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_4840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3348 10.2812H10.1342L9.75928 12.1562H10.7097L10.3348 10.2812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.918 14.0312C18.1204 14.575 18.3896 15.0151 18.6875 15.3896C18.9855 15.0151 19.2859 14.5749 19.4883 14.0312H17.918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5935 8.84375H14.7722L15.986 18.5837C16.0075 18.9821 15.8986 19.3572 15.6386 19.6508L13.583 22H20.5935C21.369 22 21.9998 21.3692 21.9998 20.5938V10.2812C21.9998 9.50581 21.369 8.84375 20.5935 8.84375ZM20.5935 14.0312H20.4684C20.2016 14.887 19.7787 15.5566 19.3391 16.0844C19.6834 16.3993 20.0517 16.6575 20.4178 16.9467C20.6196 17.1083 20.6526 17.4031 20.4905 17.6055C20.3292 17.8075 20.0333 17.8403 19.8318 17.6783C19.434 17.3643 19.0607 17.1015 18.6873 16.7588C18.3139 17.1015 17.9718 17.3643 17.574 17.6783C17.3725 17.8403 17.0766 17.8075 16.9153 17.6055C16.7532 17.4031 16.7862 17.1083 16.9881 16.9467C17.3542 16.6575 17.6911 16.3993 18.0355 16.0844C17.5959 15.5566 17.2042 14.887 16.9375 14.0312H16.8123C16.5532 14.0312 16.3435 13.8216 16.3435 13.5625C16.3435 13.3034 16.5532 13.0938 16.8123 13.0938H18.2185V12.625C18.2185 12.3659 18.4282 12.1562 18.6873 12.1562C18.9464 12.1562 19.156 12.3659 19.156 12.625V13.0938H20.5935C20.8526 13.0938 21.0623 13.3034 21.0623 13.5625C21.0623 13.8216 20.8526 14.0312 20.5935 14.0312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6301 7.23184C13.5427 6.52962 12.9426 6 12.2349 6H7.40625C6.63081 6 6 6.63081 6 7.40625V17.7812C6 18.5567 6.63081 19.1875 7.40625 19.1875C10.2084 19.1875 12.2243 19.1875 14.7985 19.1875C14.9352 19.0312 15.0498 18.9333 15.0547 18.7293C15.0559 18.6781 13.6365 7.28259 13.6301 7.23184ZM11.7483 14.9596C11.4997 15.0107 11.2479 14.8494 11.1967 14.592L10.8971 13.0938H9.57172L9.27213 14.592C9.22178 14.8456 8.97731 15.0122 8.72053 14.9596C8.46694 14.9088 8.30213 14.6621 8.35294 14.408L9.29041 9.7205C9.33434 9.50169 9.52663 9.34375 9.75 9.34375H10.7188C10.9421 9.34375 11.1344 9.50169 11.1783 9.7205L12.1158 14.408C12.1667 14.6621 12.0019 14.9088 11.7483 14.9596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4771 20.125L11.5575 20.7682C11.6111 21.1989 11.8973 21.6381 12.3681 21.8574C13.2564 20.8795 12.719 21.4711 13.9418 20.125H11.4771Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_4840",
    x1: 14,
    y1: 0,
    x2: 14,
    y2: 29.1546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9027E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58297B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_4840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeLanguage);
export default __webpack_public_path__ + "static/media/Change-Language.f1a5ad145e064b046a9756e620991900.svg";
export { ForwardRef as ReactComponent };